import ProfileCompletionBanner from "./components/ProfileCompletionBanner";
import DashboardMobileHeader from "./components/DashboardMobileHeader";
import AssignmentPendingBanner from "./components/AssignmentPendingBanner";
import ApplicationPendingBanner from "./components/ApplicationPendingBanner";
import CompleteAssignmentPopUp from "./components/CompleteAssignmentPopUp";
import AssignmentRejectionBanner from "./components/AssignmentRejectionBanner";
import ApplicationRejectionBanner from "./components/ApplicationRejectionBanner";
import IncompleteApplicationReminderBanner from "./components/IncompleteApplicationReminderBanner";
import { TUser } from "@/types/types";
import { useProfileCompletion } from "@/hooks/useProfileCompletion";
import ResetPasswordBanner from "./components/ResetPasswordBanner";
import ShipProduct from "./components/ShipProduct";
import { useGetReshippingDataQuery } from "@/redux/feature/productShipping/productShipping";
import { useCreatorStatus } from "@/hooks/useCreatorStatuts";
import { useGlobalContext } from "@/context/GlobalContext";
import { useMemo, useState } from "react";
import CreatorTats from "./components/CreatorTats";
import AssignmentBanner from "./components/AssignmentBanner";
import Modal from "@/components/ui/Modal";
import AssignmentSubmissionModal from "../assignmentSubmission/AssignmentSubmissionModal";
import { CustomButton } from "@/components/ui/Buttons";
import { Calendar } from "lucide-react";
import { AvailabilityModal } from "../sameDayDelivery/AvailabilityModal";
import { useAppSelector } from "@/redux/hooks/hooks";

const Dashboard = () => {
  const { userData } = useGlobalContext();
  const [showSameDayDeliveryModal, setShowSameDayDeliveryModal] =
    useState(false);
  const userEmail = useAppSelector((state) => state?.auth?.user?.email);

  const handleConfirm = (data: any) => {
    console.log("Confirmed availability:", data);
  };

  const { data: getReshippingData, error } = useGetReshippingDataQuery(
    userData?.creator_id as string,
    {
      skip: !userData?.creator_id,
    },
  );

  const reshippingData = getReshippingData?.data[0];

  // Profile Completion status
  const { isProfileComplete } = useProfileCompletion(userData as TUser);

  const { isCreatorApproved, status, rejectedReasons, isLoading, isError } =
    useCreatorStatus(userData?.email);

  console.log(status);

  const showTatAndSameDayBanner =
    status?.isCreatorApproved || status?.isOverwritten;
  // Determine if a popup should be shown
  const shouldShowPopup = status?.isAppApprovedAwaitingAssignment;
  const shouldSkipJobs =
    !userEmail ||
    isError ||
    shouldShowPopup ||
    (status?.isNotInitiated && !isLoading);
  const renderPopup = () => {
    if (status?.isAppApprovedAwaitingAssignment) {
      return <CompleteAssignmentPopUp />; // your existing popup
    }
    return null;
  };

  return (
    <div className="relative min-h-[85vh]">
      <div
        className={`px-4 md:px-11 pt-8 pb-10 ${
          shouldShowPopup ? "filter blur-sm" : ""
        }`}
      >
        <div>
          <h1 className="text-base md:text-xl leading-5 tracking-[-1%] mb-2.5 font-medium">
            Dashboard
          </h1>
        </div>

        {!shouldSkipJobs && <CreatorTats />}

        {!shouldSkipJobs && (
          <div className="bg-card mt-5 rounded-xl border border-border p-6 shadow-sm">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div className="space-y-2">
                <h2 className="text-lg font-semibold text-foreground">
                  Available for <span className="text-accent">Same-Day</span>{" "}
                  Projects?
                </h2>
                <p className="text-sm text-muted-foreground max-w-md">
                  Mark yourself available for single-day delivery to receive
                  urgent projects and get paid today. You'll have 3–4 hours to
                  complete each project.
                </p>
              </div>

              <CustomButton
                onClick={() => setShowSameDayDeliveryModal(true)}
                variant="outline"
                className="gap-2 flex items-center border-primary text-primary hover:bg-primary/5"
              >
                <Calendar className="w-4 h-4" />
                Modify Slots
              </CustomButton>
            </div>
          </div>
        )}

        <div className="relative mt-6">
          {/* Conditionally render banners based on status */}

          {isLoading ? (
            <p className="py-20 flex justify-center items-center font-semibold animate-pulse">
              Loading...
            </p>
          ) : (
            <>
              {isError ? (
                <>
                  <p className="py-20 flex justify-center items-center font-semibold animate-pulse">
                    Some thing went wrong...
                  </p>
                </>
              ) : (
                <>
                  {userData?.needsPasswordChanged && <ResetPasswordBanner />}

                  {!reshippingData?.status?.isShipping_started &&
                    reshippingData?.status?.is_new_actor_assigned && (
                      <ShipProduct
                        creator_shipping_details={
                          reshippingData?.creator_shipping_details
                        }
                        id={reshippingData?._id}
                      />
                    )}

                  {status?.isNotInitiated && (
                    <IncompleteApplicationReminderBanner />
                  )}

                  {status?.isApplicationPending && <ApplicationPendingBanner />}

                  {status?.isOverwritten && (
                    <div className="mt-4">
                      <AssignmentBanner />
                    </div>
                  )}

                  {status?.isApplicationRejected && (
                    <ApplicationRejectionBanner
                      rejectedReason={rejectedReasons}
                    />
                  )}

                  {status?.isAssignmentRejected && (
                    <AssignmentRejectionBanner />
                  )}

                  {!isProfileComplete && (
                    <ProfileCompletionBanner data={userData as TUser} />
                  )}
                </>
              )}
            </>
          )}
        </div>

        {/* <div className="mt-4">
          <DashboardMobileHeader />
        </div> */}
      </div>

      {/* Popup layer */}
      {shouldShowPopup && (
        <div className="absolute inset-0 z-40 top-[25%] flex justify-center h-fit">
          {renderPopup()}
        </div>
      )}
      <AvailabilityModal
        isOpen={showSameDayDeliveryModal}
        setOpen={setShowSameDayDeliveryModal}
        onConfirm={handleConfirm}
      />
    </div>
  );
};

export default Dashboard;
